import { Link } from 'react-router-dom';
import { Cloud, LogIn, UserCircle } from 'lucide-react';
import { UserButton, useAuth } from '@clerk/react';

import { ACCOUNT_SYNC_ENABLED } from './config';
import { Button } from '@/components/ui/button';

export function AccountButton() {
  if (ACCOUNT_SYNC_ENABLED) {
    return <ConfiguredAccountButton />;
  }

  if (!ACCOUNT_SYNC_ENABLED) {
    return (
      <Link to="/account">
        <Button variant="outline" size="sm" className="gap-1.5">
          <Cloud className="h-4 w-4" />
          <span className="hidden sm:inline">Account</span>
        </Button>
      </Link>
    );
  }
  return null;
}

function ConfiguredAccountButton() {
  const { isSignedIn } = useAuth();
  if (isSignedIn) {
    return (
      <div className="flex items-center gap-1">
        <Link to="/account">
          <Button variant="ghost" size="sm" className="gap-1.5">
            <UserCircle className="h-4 w-4" />
            <span className="hidden sm:inline">Account</span>
          </Button>
        </Link>
        <UserButton />
      </div>
    );
  }
  return (
    <Link to="/account">
      <Button variant="secondary" size="sm" className="gap-1.5">
        <LogIn className="h-4 w-4" />
        <span className="hidden sm:inline">Sign in</span>
      </Button>
    </Link>
  );
}
